import { useState } from "react";

export const useAlmacenRow = ({ item }) => {
    const [hoveredId, setHoveredId] = useState(null);

    // Lo enviado a producción lo entrega el backend: en el almacén de reproceso
    // es lo que las tancadas consumieron y en el resto la resta del conteo del
    // periodo, que viene vacía mientras el almacén siga pendiente
    return {
        hoveredId,
        setHoveredId,
        invFinalLab: item.final.kg_secos_lab,
        invFinalLiq: item.final.kg_secos_liq,
        enviadoProdLab: item.enviado.kg_secos_lab,
        enviadoProdLiq: item.enviado.kg_secos_liq,
    };
};
